import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';

@Component({
  selector: 'access-denied-page',
  templateUrl: './access-denied-page.component.html',
  styleUrls: ['./access-denied-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccessDeniedPageComponent implements OnInit {
  errorTitle: string;
  errorMessage: string;

  constructor(private route: ActivatedRoute, private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this._fuseTranslationLoaderService.loadTranslations(english, vn);
  }

  ngOnInit() {
    this.route.data.subscribe(routeData => {
      this.errorTitle = routeData.errorTitle;
      this.errorMessage = routeData.errorMessage;
    });
  }
}
